package pl.decks.personal.pages.ievp.foreword

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import pl.decks.personal.components.layouts.site.SiteLayoutStylesheet
import pl.decks.personal.extensions.toSitePalette
import pl.decks.personal.pages.ievp.IEVPStylesheet
import pl.decks.personal.styles.SiteLayout

private val NOTES = listOf(
    "Bioptimus is writing the lingua franca of biological data. It instantly topped position of dialects to learn",
    "To speak it is not a fresh start - I modelled metabolic pathways as graphs and published on Lévy-like eye movements in Chaos",
    "You are surrounded by an unmatched data moat, found nowhere else",
    "The tools and paradigms used to wrangle it - AWS, Python, SQL, QC, dashboards - I have expertise in",
    "Your culture in four words is honesty, collaboration, ambition and self-distance. My longing is to be part of an unexpected discovery, however small",
    "The environment is pitched as ambiguous, fast-paced and evolving. I am a founder - I can shape a role, not only execute it",
    "Maps are to be drawn, not followed",
    "AI I know in theory and in practice. Time for the foundation",
)

@OptIn(DelicateApi::class)
@Composable
fun BioptimusForeword() = Column(
    modifier = SiteLayoutStylesheet.Page.Content.toModifier()
        .padding(left = IEVPStylesheet.Vars.contentPaddingLeft.value(), top = SiteLayout.Space.Medium)
        .gap(SiteLayout.Space.Small)
        .setVariable(ForewordStylesheet.Vars.pointBackgroundColor, ColorMode.current.toSitePalette().surface)
        .setVariable(ForewordStylesheet.Vars.pointVisitedBackgroundColor, ColorMode.current.toSitePalette().accents.primary)
        .setVariable(ForewordStylesheet.Vars.pointStrokeColor, ColorMode.current.toSitePalette().accents.primary),
    horizontalAlignment = Alignment.CenterHorizontally,
) {
    CoverLetterText(
        "The machinery life evolved to solve its challenges leaves me in awe. The smallest scale is the most humbling and messy. It tells a story where new complexity emerges the moment the field is deemed solved. A tale I follow closely, and want to contribute a few more words to.",
        "I admire what science is: rigor and relentless pursuit of the unknown. The fact that your manifesto is written like a publication tells me you feel the same. It warms my heart how much of it is focused on rare diseases. It's a topic I've found moving ever since I learned, back at PeakData, how humanely Sanofi treats it compared to the rest.",
        "The Data Operations role draws on skills from various backgrounds. My experience says such a composition is rare. I practice humility and it shows on this page. This once, though, I'll bluntly say it: I have what's required. And I'm well versed in bridging domains.",
        "The genetic match runs deeper, into the DNA:",
    )
    val breakpoint = rememberBreakpoint()
    val (segments, height) = if (breakpoint < Breakpoint.MD) 2 to 140.0 else 3 to 200.0
    val pointsPerSegment = 6
    val takenRungs = remember(segments) {
        (0 until segments * pointsPerSegment).shuffled().take(NOTES.size).sorted()
    }
    NotesHelix(
        segments = segments,
        pointsPerSegment = pointsPerSegment,
        notes = takenRungs.zip(NOTES).toMap(),
        helixHeight = height,
        mainStrainColor = ColorMode.current.toSitePalette().accents.primary,
        secondaryStrainColor = ColorMode.current.toSitePalette().accents.secondary,
    )
}
